var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBtnDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 10,
    fill: "white",
    stroke: "#02000E",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8485 7.88311C14.8965 7.83513 14.9346 7.77816 14.9607 7.71545C14.9867 7.65274 15.0001 7.58552 15.0001 7.51763C15.0002 7.44974 14.9868 7.3825 14.9609 7.31976C14.935 7.25702 14.8969 7.2 14.8489 7.15197C14.801 7.10393 14.744 7.06581 14.6813 7.03979C14.6186 7.01377 14.5513 7.00036 14.4835 7.00032C14.4156 7.00028 14.3483 7.01361 14.2856 7.03955C14.2228 7.06549 14.1658 7.10354 14.1178 7.15152L11 10.2693L7.88311 7.15152C7.78609 7.0545 7.65451 7 7.51731 7C7.38011 7 7.24853 7.0545 7.15152 7.15152C7.0545 7.24853 7 7.38011 7 7.51731C7 7.65451 7.0545 7.78609 7.15152 7.88311L10.2693 11L7.15152 14.1169C7.10348 14.1649 7.06538 14.222 7.03938 14.2847C7.01338 14.3475 7 14.4148 7 14.4827C7 14.5506 7.01338 14.6179 7.03938 14.6807C7.06538 14.7434 7.10348 14.8004 7.15152 14.8485C7.24853 14.9455 7.38011 15 7.51731 15C7.58525 15 7.65252 14.9866 7.71528 14.9606C7.77804 14.9346 7.83507 14.8965 7.88311 14.8485L11 11.7307L14.1178 14.8485C14.2148 14.9454 14.3463 14.9998 14.4835 14.9997C14.6206 14.9996 14.752 14.945 14.8489 14.848C14.9458 14.751 15.0002 14.6195 15.0001 14.4824C15 14.3453 14.9455 14.2138 14.8485 14.1169L11.7307 11L14.8485 7.88311Z",
    fill: "#112211",
    stroke: "black",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnDelete);
export default __webpack_public_path__ + "static/media/btn_delete.c4fc5ae03cfd714c8382155a8f051c81.svg";
export { ForwardRef as ReactComponent };